import { app } from '../index';

export const gentminvparams = customers => {
  var newcustomers = Array.from(customers);

  return app
    .service('tminvparams')
    .find()
    .then(response => {    
      response = response.data ? response.data : response;

      return newcustomers.map(cust => {
        var param = response.find(r => r.custnumber === cust.custnumber)
        return {
          ...cust,
          nexttmnumber: param.nexttmnumber,
          nextinvnumber: param.nextinvnumber,
          nextwonumber: param.nextwonumber,
          nextestnumber: param.nextestnumber
        };
      });
    })
};



// WEBPACK FOOTER //
// ./src/services/tminvparams.js